var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwallowtailFlagSummer(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.202h230.716V.158H0L16.05 16.18 0 32.202z",
    fill: "#327D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwallowtailFlagSummer);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='231' height='33' viewBox='0 0 231 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M0 32.2021H230.716V0.158203H0L16.0498 16.1802L0 32.2021Z' fill='%23327D45'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };